<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Community Grants Application</span>
    <span class="example-spacer"></span>
    <button [fxShow.lt-md]="true" [fxShow]="false" mat-icon-button
        (click)="toHome()">
        <mat-icon>home</mat-icon>
    </button>
</mat-toolbar> -->
<mat-toolbar *ngIf="isFormExpired && (cgForm.value.statusId === 2 ||
    cgForm.value.statusId === undefined || cgForm.value.statusId === null)"
    color="primary" style="background-color: #CE1126">
    <span>Community Grants Application has been expired!</span>
</mat-toolbar>
<div class="mobile-action-bar">
    <div class="action-mobile-button warn-button" (click)="onCancel()"
        color="warn">Cancel</div>
    <div class="action-mobile-button secondary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()" color="primary">Save</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()" color="primary">Submit</div>
    <div class="action-mobile-button secondary-button" *ngIf="isShowSaveButton"
        (click)="onSubmit()"
        color="primary">Save
        Change(s)</div>
    <div class="action-mobile-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onWithdrawRejectReassign('Rejected')" color="warn">Reject</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()" color="primary">Approve</div>
    <!-- <button mat-flat-button fxFlex *ngIf="isShowReassignBtn"
            (click)="onWithdrawReject('Reassigned')" color="primary">Reassign To CIT</button> -->
    <div class="action-mobile-button warn-secondary-button"
        *ngIf="isShowWithdrawBtn"
        (click)="onWithdrawRejectReassign('Withdrawn')"
        color="warn">Withdraw</div>
</div>

<div class="info-container">
    <mat-card-subtitle class="leading-9">
        <p>Through our Community Grants program, LG&E and KU support
            non-profit programs and activities focusing on education,
            environment, economic development, health and human
            services, and diversity.</p>
        <p>
            <!-- FOR MORE INFORMATION SEE POLICY: -->
            <a
                href="https://lge-ku.com/sites/default/files/CharitableContributionsExternalUser.pdf"
                target="_blank">General Instructions</a>
        </p>
        <p>
            <b>*</b> = Mandatory
        </p>
    </mat-card-subtitle>
</div>
<div autoscroll="true" class="content" [@routeAnimation]="true">
    <form class="form-content" [formGroup]="cgForm"
        enctype="multipart/form-data">
        <!-- <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center"
            static [fxShow.lt-sm]="true"
            [fxShow]="false">
            <button mat-flat-button class="fab" (click)="onCancel()"
                color="warn">Cancel</button>
            <button mat-flat-button class="fab" *ngIf="isShowSaveAsDraft"
                (click)="onSaveAsDraft()"
                color="primary">Save</button>
            <button mat-flat-button class="fab" *ngIf="isShowSaveAsDraft"
                (click)="onSubmit()"
                color="primary">Submit</button>
            <button mat-flat-button class="fab" *ngIf="isShowSaveButton"
                (click)="onSubmit()" color="primary">Save
                Change(s)</button>
            <button mat-flat-button class="fab" *ngIf="isShowApproveBtn"
                (click)="onWithdrawRejectReassign('Rejected')" color="warn">Reject</button>
            <button mat-flat-button class="fab" *ngIf="isShowApproveBtn"
                (click)="onApprove()"
                color="primary">Approve</button>
            <button mat-flat-button class="fab" *ngIf="isShowReassignBtn"
                (click)="onWithdrawRejectReassign('Reassigned')"
                color="primary">Reassign To CIT</button>
            <button mat-flat-button class="fab" *ngIf="isShowWithdrawBtn"
                (click)="onWithdrawRejectReassign('Withdrawn')" color="warn">Withdraw</button>
        </div> -->
        <!-- <mat-card fxLayout="column">
            <mat-form-field>
                <input type="text" matInput placeholder="Request Name " maxlength="50" formControlName="requestName"
                    [readonly]='isReadOnly'>
                <mat-hint>(Example: Summer Reading Program)</mat-hint>
            </mat-form-field>
        </mat-card> -->
        <!--orgInfo-->
        <div formGroupName="OrgInfo" fxLayout="column" fxLayoutGap="16px">
            <div class="form-question-group" fxLayout="column">
                <mat-card-subtitle>
                    <b>Organization Information</b>
                </mat-card-subtitle>
                <mat-form-field>
                    <input readonly type="text" formControlName="name" matInput
                        placeholder="Organization Name">
                </mat-form-field>
                <mat-card-subtitle>Is "Payable To" name different than the
                    Organization Name? *</mat-card-subtitle>
                <mat-radio-group formControlName="payToOption"
                    [disabled]="isReadOnly ||
                    (cgForm.get(['OrgInfo','payToOption']).value === 'Yes' &&
                    cgForm.get(['OrgInfo','name']).value.length> 80)">
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-form-field fxLayout="column"
                    *ngIf="cgForm.get(['OrgInfo','payToOption']).value ===
                    'Yes'">
                    <input [readonly]="isReadOnly" type="text"
                        formControlName="payTo" matInput placeholder="Payable
                        To" maxlength="80">
                </mat-form-field>
                <mat-form-field>
                    <input type="text" readonly formControlName="EIN" matInput
                        placeholder="EIN">
                </mat-form-field>

                <mat-form-field>
                    <input type="text" formControlName="address1" matInput
                        placeholder="Address1" maxlength="35"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" formControlName="address2" matInput
                        placeholder="Address2" maxlength="35"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" formControlName="city" matInput
                        placeholder="City" maxlength="50"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field>
                    <mat-select placeholder="State" formControlName="state"
                        [disabled]='isReadOnly'>
                        <mat-option *ngFor="let state of states"
                            [value]="state">{{state}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" formControlName="zipCode" zipCode
                        matInput placeholder="Zip Code" maxlength="10"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field>
                    <input type="text" formControlName="webAddress" matInput
                        placeholder="Web Address" maxlength="35"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field *ngIf='!isTaxExemptEditable'>
                    <input type="text" matInput placeholder="Tax-Exempt Status"
                        maxlength="15"
                        [value]="getTaxExemptStatus(cgForm.get(['OrgInfo','subsection_501']).value)"
                        readonly>
                </mat-form-field>
                <mat-form-field *ngIf='isTaxExemptEditable'>
                    <mat-select placeholder="Tax Exempt Status"
                        formControlName="subsection_501"
                        [disabled]='isReadOnly'>
                        <mat-option *ngFor="let subsection of taxExemptList"
                            [value]="subsection">
                            {{getTaxExemptStatus(subsection)}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-card-subtitle>Current operating budget *
                </mat-card-subtitle>
                <mat-form-field>
                    <input DecimalTrail maxlength="15" type="text"
                        [textMask]="{mask: twoDecMask}" formControlName="budget"
                        matInput [attr.disabled]='isReadOnly'>
                    <span matPrefix>$&nbsp;</span>
                </mat-form-field>
                <mat-card-subtitle>Number of paid staff. *</mat-card-subtitle>
                <mat-form-field>
                    <input DecimalTrail [textMask]="{mask: oneDecMask}"
                        type="text" maxlength='15' formControlName="ftStaff"
                        placeholder="Full-time:" matInput
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-form-field>
                    <input DecimalTrail [textMask]="{mask: oneDecMask}"
                        type="text" maxlength='15' formControlName="ptStaff"
                        placeholder="Part-time:" matInput
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
                <mat-card-subtitle>Brief statement describing organization's
                    purpose/mission and goals. *
                </mat-card-subtitle>
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='500'
                        formControlName="orgDesc" matInput matTextareaAutosize
                        matAutosizeMinRows="3" matAutosizeMaxRows="5"
                        [attr.disabled]='isReadOnly'></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 500</mat-hint>
                </mat-form-field>
                <mat-card-subtitle *ngIf="cgForm.get('OrgInfo').value.president
                    === null ||
                    cgForm.get('OrgInfo').value.president === ''">
                    <!-- Name of President / CEO / Executive Director. * -->
                </mat-card-subtitle>
                <mat-form-field>
                    <input type="text" formControlName="president" matInput
                        placeholder="Name of President / CEO / Executive
                        Director." maxlength="25" [attr.disabled]='isReadOnly'>
                    <mat-hint>Example: Jane Doe</mat-hint>
                </mat-form-field>
                <mat-form-field>
                    <input type="email" matInput placeholder="Email Address"
                        maxlength="254" formControlName="email"
                        [attr.disabled]='isReadOnly'>
                    <mat-hint>Example: you@example.com</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <!--orgContact-->
        <div class="form-question-group" formGroupName="OrgContactInfo"
            fxLayout="column"
            fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Organization Contact Information</b>
            </mat-card-subtitle>
            <br>
            <mat-card-subtitle><b><i>
                        *All communication will be directed to the
                        individual listed below.</i>
                </b>
            </mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput placeholder="First Name"
                    maxlength="150" formControlName="firstName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Last Name"
                    maxlength="150" formControlName="lastName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" phone formControlName="phone" maxlength="12"
                    matInput placeholder="Phone Number"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: xxx-xxx-xxxx</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <input type="email" matInput placeholder="Email Address"
                    maxlength="254" formControlName="email"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: you@example.com</mat-hint>
            </mat-form-field>
        </div>
        <!--Additional Org Info-->
        <div class="form-question-group" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>The following LG&E, KU or ODP employees are
                affiliated with this organization as a board member or regular
                volunteer.*:
            </mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput placeholder="LG&E KU Employee Name"
                    maxlength="50" formControlName="empName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-card-subtitle>Is your organization interested in providing
                volunteer opportunities for LG&E and KU employees? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="isVolunteerProvided"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-subtitle>This organization is affiliated with a national
                organization. *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="isNationalOrgAsc"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-form-field *ngIf="cgForm.get('isNationalOrgAsc').value ===
                'Yes'">
                <input [readonly]="isReadOnly" type="text"
                    formControlName="nationalOrgAscDescr" matInput
                    placeholder="If Yes, what is the name of the national
                    organization?" maxlength="50">
            </mat-form-field>
            <mat-card-subtitle>This organization is a membership organization.
                *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="isMembership"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-subtitle *ngIf="cgForm.get('fundSrc')?.valid">This
                organization receives funding from the following sources: *
                <br> (Please check all that apply and provide the donor name in
                the field provided)
            </mat-card-subtitle>
            <mat-error *ngIf="cgForm.get('fundSrc')?.invalid"><b>This
                    organization receives funding from the
                    following sources: *</b>
                <br> (Please check all that apply and provide the donor name in
                the field provided)
            </mat-error>
            <!--for mobile screen, due to fxLayout on div break mat-selection-list binding -->
            <mat-selection-list #donorList fxHide fxShow.xs="true"
                fxLayoutGap="20px" formControlName="fundSrc"
                [disabled]='isReadOnly'>
                <div *ngFor="let src of fundSources">
                    <mat-list-option checkboxPosition="before"
                        class="matlistOption" [value]="src">
                        {{src}}
                    </mat-list-option>
                    <mat-card-content fxLayout="column"
                        *ngIf="isShowFundSrcTextField(src)">
                        <mat-form-field>
                            <input [readonly]='isReadOnly'
                                [formControlName]="getFundSrcControlName(src)"
                                type="text" matInput maxlength="150"
                                [placeholder]="getFundSrcPlaceholder(src)"
                                (keydown)="$event.stopPropagation()">
                            <mat-hint align="end">({{
                                cgForm.get(getFundSrcControlName(src)).value.length}}/150
                                characters limit)</mat-hint>
                        </mat-form-field>
                    </mat-card-content>
                </div>
            </mat-selection-list>
            <!--for big screen, display side by side-->
            <mat-selection-list #donorList fxShow fxHide.xs="true"
                fxLayoutGap="12px" formControlName="fundSrc"
                [disabled]='isReadOnly'>
                <div *ngFor="let src of fundSources">
                    <mat-list-option checkboxPosition="before"
                        class="matlistOption" [value]="src" fxFlex="25%"
                        fxFlexFill>
                        {{src}}
                    </mat-list-option>
                    <mat-card-content fxLayout="column"
                        *ngIf="isShowFundSrcTextField(src)" fxFlex="75%"
                        fxFlexFill>
                        <mat-form-field>
                            <input [readonly]='isReadOnly'
                                [formControlName]="getFundSrcControlName(src)"
                                type="text" matInput maxlength="150"
                                [placeholder]="getFundSrcPlaceholder(src)"
                                (keydown.space)="$event.stopPropagation()">
                            <mat-hint align="end">({{
                                cgForm.get(getFundSrcControlName(src)).value.length}}/150
                                characters limit)
                            </mat-hint>
                        </mat-form-field>
                    </mat-card-content>
                </div>
            </mat-selection-list>
            <mat-card-subtitle>This organization has a newsletter that
                acknowledges donors and sponsors. *
            </mat-card-subtitle>
            <mat-card-content>
                <mat-radio-group formControlName="hasNewsletter"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-subtitle *ngIf="cgForm.value.serviceArea === null ||
                cgForm.value.serviceArea.length === 0">
                Service Area(s): *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='isReadOnly' placeholder="Service
                    Area(s)" formControlName="serviceArea" multiple
                    [disabled]='isReadOnly'>
                    <mat-option *ngFor="let serviceArea of serviceAreas"
                        [value]="serviceArea">{{serviceArea}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-card-subtitle *ngIf="cgForm.value.categoryFunding === null ||
                cgForm.value.categoryFunding.length === 0">The funding requested
                with this application will be dedicated to:
                *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='isReadOnly' placeholder="The funding
                    requested with this application
                    will be dedicated to" formControlName="categoryFunding">
                    <mat-option value="General Operating Support">General
                        Operating Support</mat-option>
                    <mat-option value="Support of an Event">Support of an
                        Event</mat-option>
                    <mat-option value="Support of a Program">Support of a
                        Program
                    </mat-option>
                    <mat-option value="Other">Other</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-card-subtitle *ngIf="hasOtherCatFund"
                [ngClass]="{'red-warning':
                cgForm.get('categoryFundingOther').invalid}">Please specify
                Other Category of Funding. *</mat-card-subtitle>
            <mat-card-content *ngIf="hasOtherCatFund">
                <mat-form-field fxLayout="column">
                    <input [readonly]='isReadOnly'
                        formControlName="categoryFundingOther" type="text"
                        matInput maxlength="25">
                    <mat-hint align="end">({{
                        cgForm.get('categoryFundingOther').value.length}}/25
                        characters limit)</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle
                *ngIf="cgForm.value.categoryRequest ===''">Category
                of Request: *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='isReadOnly' placeholder="Category of
                    Request:" formControlName="categoryRequest"
                    disableOptionCentering [disabled]='isReadOnly'>
                    <mat-option *ngFor="let catReq of catReqs"
                        [value]="catReq">{{catReq}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-card-subtitle *ngIf="hasOtherCatReq"
                [ngClass]="{'red-warning':
                cgForm.get('categoryRequestOther').invalid}">Please specify
                Other Category of Request. *</mat-card-subtitle>
            <mat-card-content *ngIf="hasOtherCatReq">
                <mat-form-field fxLayout="column">
                    <input [readonly]='isReadOnly'
                        formControlName="categoryRequestOther" type="text"
                        matInput maxlength="25">
                    <mat-hint align="end">({{
                        cgForm.get('categoryRequestOther').value.length}}/25
                        characters limit)</mat-hint>
                </mat-form-field>
            </mat-card-content>
        </div>
        <!--Project Info-->
        <div class="form-question-group" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Project Information</b>
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Project Name"
                        maxlength="30" formControlName="projectName" matInput
                        type="text">
                    <mat-hint>(Example: Summer Reading Program, General
                        Operating Support, Annual Fundraiser)</mat-hint>
                    <mat-hint align="end">({{
                        cgForm.get('projectName').value.length}}/30 characters
                        limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Location"
                        maxlength="35" formControlName="projectLocation"
                        matInput type="text">
                    <mat-hint align="end">({{
                        cgForm.get('projectLocation').value.length}}/35
                        characters limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Project Date"
                        maxlength="25" formControlName="projectDate" matInput
                        type="text">
                    <mat-hint align="end">({{
                        cgForm.get('projectDate').value.length}}/25 characters
                        limit)</mat-hint>
                </mat-form-field>
                <mat-form-field>
                    <input [readonly]='isReadOnly' DecimalTrail
                        placeholder="Total Cost" maxlength="10"
                        [textMask]="{mask: twoDecMask}"
                        formControlName="projectCost" matInput type="text">
                    <span matPrefix>$&nbsp;</span>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' DecimalTrail
                        placeholder="Amount requested from LG&E/KU/ODP"
                        maxlength="10" formControlName="requestedAmount"
                        [textMask]="{mask: twoDecMask}" matInput type="text">
                    <span matPrefix>$&nbsp;</span>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>
                <b>Brief</b> Project Summary. *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='500'
                        [attr.disabled]='isReadOnly'
                        formControlName="projectSummary" matInput
                        matTextareaAutosize matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 500</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>
                Additional Project Information. *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='isReadOnly'
                        formControlName="addProjectInfo" matInput
                        matTextareaAutosize matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
        </div>
        <!--List companies-->
        <div class="form-question-group" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>List 5 companies/businesses contributing to
                <u><b>this
                        project</b></u> and the amount contributed (if
                applicable).
            </mat-card-subtitle>
            <div class="table-container mat-elevation-z8">

                <table class='compListTable' style="padding: 16px; width: 100%"
                    formArrayName="companyList">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company Name</th>
                            <th>Contribution</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i" *ngFor="let company of
                            cgForm.get('companyList')['controls']; let i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field style="width: 350px; padding:
                                    0px 10px;">
                                    <input style="text-align: center;"
                                        type="text" matInput maxlength="25"
                                        formControlName="companyName"
                                        [readonly]='isReadOnly'>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field style="width: 250px; padding:
                                    0px 10px;">
                                    <input style="text-align: center;"
                                        type="text" DecimalTrail matInput
                                        maxlength="10"
                                        formControlName="contribution"
                                        [textMask]="{mask: twoDecMask}"
                                        [readonly]='isReadOnly'>
                                    <span matPrefix>$&nbsp;</span>
                                </mat-form-field>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--Additional Project Info-->
        <div class="form-question-group" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>What community need are you addressing?
                *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea [attr.disabled]='isReadOnly' CharLimit
                        [MaxChar]='1500' formControlName="communityNeed"
                        matInput matTextareaAutosize matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Describe how the community will benefit,
                including specific results and metrics (i.e. number of people
                served, participant achievements, etc.) from the last three
                years, if requested funding will support a recurring project.
                *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea [attr.disabled]='isReadOnly' CharLimit
                        [MaxChar]='1500' formControlName="communityBenefit"
                        matInput matTextareaAutosize matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Is this project being conducted in collaboration
                with any other organization(s)? List all partnerships. *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='isReadOnly'
                        formControlName="partnerships" matInput
                        matTextareaAutosize matAutosizeMinRows="4"
                        matAutosizeMaxRows="15"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>Describe the plans for sustaining the proposed
                project in future years. *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [MaxChar]='1500'
                        [attr.disabled]='isReadOnly' formControlName="plans"
                        matInput matTextareaAutosize matAutosizeMinRows="4"
                        matAutosizeMaxRows="15"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-subtitle>If you are a successful awardee, please describe
                how your organization will publicly acknowledge this
                contribution. *
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <textarea CharLimit [attr.disabled]='isReadOnly'
                        [MaxChar]='1500' formControlName="successAwardedDesc"
                        matInput matTextareaAutosize matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"></textarea>
                    <mat-hint align="end">Characters count (not includes spaces)
                        0 / 1500
                    </mat-hint>
                </mat-form-field>
            </mat-card-content>
            <!-- <mat-card-subtitle>If you are a successful awardee, would you prefer
                that the grant payment be made by credit card? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="payment"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary" value="CREDIT">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="CHECK">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content> -->
        </div>
        <!--Attachments-->
        <div class="form-question-group" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Attachments</b>
            </mat-card-subtitle>
            <div class="rounded-2xl bg-green-100/40 p-8" fxLayout="column"
                fxLayoutGap="16px">
                <!--501c03-->
                <mat-card-subtitle>1. Please upload a copy of your
                    organization’s most recent 501(c)(3) tax-exempt IRS
                    determination letter.
                    <b>(PDF Only)*</b>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event, 'TaxExemptAttach')"
                        #fileInputTaxExempt>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            cgForm.get('TaxExemptAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                (click)="DownloadAttachFile('TaxExemptAttach',file.value.attachName)"
                                *ngIf="cgForm.get('TaxExemptAttach')['controls'].length
                                != 0">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                (click)="resetFileInput('TaxExemptAttach')"
                                *ngIf="cgForm.get('TaxExemptAttach')['controls'].length
                                != 0 && !isReadOnly">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            cgForm.get('TaxExemptAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('TaxExemptAttach',file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
                <br>
                <br>
                <!--W9-->
                <mat-card-subtitle>2. Please upload a completed form W-9 for
                    this request.
                    <b>(PDF Only)*</b>
                    <br> Please Note: the provided W-9 must be the version
                    <a href="https://lge-ku.com/sites/default/files/W9.pdf"
                        target="_blank">here.</a>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event, 'W9Attach')"
                        #fileInputW9>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            cgForm.get('W9Attach')['controls']; let i= index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="cgForm.get('W9Attach')['controls'].length
                                != 0" (click)="DownloadAttachFile('W9Attach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="cgForm.get('W9Attach')['controls'].length
                                != 0 &&
                                !isReadOnly"
                                (click)="resetFileInput('W9Attach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="cgForm.get('W9Attach')['controls'].length != 0">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            cgForm.get('W9Attach')['controls']; let i= index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('W9Attach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
                <br>
                <br>
                <!--BoD-->
                <mat-card-subtitle>3. Please upload a list of your current Board
                    of Directors.
                    <b>(PDF Only)*</b>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event, 'BoDListAttach')"
                        #fileInputBoD>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            cgForm.get('BoDListAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="cgForm.get('BoDListAttach')['controls'].length
                                != 0"
                                (click)="DownloadAttachFile('BoDListAttach',
                                file.value.attachName)">save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="cgForm.get('BoDListAttach')['controls'].length
                                != 0 && !isReadOnly"
                                (click)="resetFileInput('BoDListAttach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="cgForm.get('BoDListAttach')['controls'].length !=
                        0">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            cgForm.get('BoDListAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('BoDListAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
                <br>
                <br>
                <!--Operating Budget-->
                <mat-card-subtitle>4. Please upload a copy of your
                    organization’s current operating budget.
                    <b>(PDF Only)*</b>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event,
                        'BudgetAttach')" #fileInputBudget>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            cgForm.get('BudgetAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="cgForm.get('BudgetAttach')['controls'].length
                                !=
                                0" (click)="DownloadAttachFile('BudgetAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="cgForm.get('BudgetAttach')['controls'].length
                                !=
                                0 && !isReadOnly"
                                (click)="resetFileInput('BudgetAttach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="cgForm.get('BudgetAttach')['controls'].length
                        !=
                        0">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            cgForm.get('BudgetAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('BudgetAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </div>
            <div class="rounded-2xl bg-green-100/40 p-8" fxLayout="column">
                <mat-card-subtitle>Additional attachment(s). <b>(PDF Only)</b>
                    <br> (Please upload any other information your organization
                    believes to be pertinent to this request.)
                </mat-card-subtitle>
                <mat-card-content>
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAddAttachFileChange($event)"
                        #fileInputAdditional multiple>

                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngIf="cgForm.get('AddAttach')['controls'].length
                            !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngIf="cgForm.get('AddAttach')['controls'].length
                            !=
                            0
                            && !isReadOnly">
                            <mat-icon color="warn" class="icon-cursor"
                                mat-list-icon color="warn"
                                (click)="resetFileInput('AddAttach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Remove all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item *ngFor="let file of
                            cgForm.get('AddAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="cgForm.get('AddAttach')['controls'].length
                                !=
                                0" (click)="DownloadAttachFile('AddAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="cgForm.get('AddAttach')['controls'].length
                                !=
                                0
                                && !isReadOnly"
                                (click)="removeAddFile(file.value.attachName)">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list>

                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="cgForm.get('AddAttach')['controls'].length !=
                        0">
                        <a class="list-item" mat-list-item
                            *ngIf="cgForm.get('AddAttach')['controls'].length
                            !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            cgForm.get('AddAttach')['controls']; let i=
                            index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('AddAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}.
                                {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </div>
        </div>
        <!--Authorized Representative Signature-->
        <div class="form-question-group" fxLayout="column"
            formGroupName="AuthorizedRep"
            fxLayoutGap="15px">
            <div class="info-container">
                <h4 style="color:red"><b>Authorization</b></h4>
                <mat-card-subtitle class="leading-9">

                    <p>
                        The signature of your organization’s authorized
                        representative below obligates your organization to
                        spend any and all funds awarded as a result of this
                        application only for the purpose(s) described within
                        this application. Awarded funds spent for any
                        other purpose will be forfeited, and your organization
                        will be obligated to return any such funds immediately.
                        LG&E, KU/ODP and the Foundation (“Granting Entities”)
                        reserve the right to revoke any award and demand the
                        return of
                        all funds spent for any purpose other than that
                        described in this application or for any other material
                        misrepresentation.
                    </p>
                    <p>
                        A request for applications made by the Granting Entities
                        does not constitute an offer or a commitment to award
                        funds. Your organization should not act in reliance on
                        an assumption that funds will be awarded.
                    </p>
                    <p>
                        This application portal and its content are provided on
                        an “as is” basis. The Granting Entities make no
                        representations or warranties, either express or
                        implied, regarding this application portal or its
                        content, and hereby specifically disclaim any and
                        all such representations or warranties of any kind,
                        including any with respect to the completeness,
                        accuracy, or currency of the content or its suitability
                        for any particular purpose.
                    </p>

                    <p>
                        The Granting Entities do not guarantee continuous,
                        uninterrupted, or secure access to this application
                        portal. Your organization is responsible for the costs
                        it incurs in preparing and submitting any application
                        using the application portal. Use of this
                        application portal is solely at each user’s own risk.
                    </p>
                    <p>
                        The Granting Entities may suspend or terminate any
                        user’s access to this application portal at any time for
                        any reason. The Granting Entities reserve the right at
                        any time, with or without notice or reasons, to
                        discontinue any application process. The
                        Granting Entities, in their sole and exclusive
                        discretion, and with or without notice or reason, may
                        (i) accept or reject any application in whole or in
                        part, (ii) reject all applications, or (iii) withdraw
                        any request for applications
                        at any time before or after submission of applications.
                        The Granting Entities retain the discretion and right to
                        change the criteria for evaluating applications even
                        after a request for applications has been released
                        and/or responses
                        to a request for applications have been received.
                    </p>
                    <p>
                        By submitting an application, your organization
                        represents that it has sufficient intellectual property
                        rights to submit the content of the application. The
                        Granting Entities reserve the right to retain copies of
                        application materials indefinitely. Use
                        of any materials containing or using the Granting
                        Entities’ names, logos or trademarks shall be subject to
                        their prior review and approval. Conditioned upon such
                        approval in Granting Entities’ case, the parties hereby
                        grant each
                        other a free, non-exclusive, limited and revocable
                        license to use their intellectual property solely in
                        accordance with the terms, conditions and intended uses
                        hereof. All other rights are reserved and retained by
                        their respective
                        owner.
                    </p>
                </mat-card-subtitle>

            </div>
            <mat-card-subtitle><b>
                    Verified and submitted by authorized representative*</b>
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input [readonly]='isReadOnly' type="text"
                        formControlName="name" maxlength="25" matInput
                        placeholder="Name">
                </mat-form-field>
                <mat-form-field fxLayout="row">
                    <input [disabled]='true' formControlName="date" readonly
                        matInput placeholder="Date Drafted/Submitted">
                    <mat-datepicker-toggle [disabled]='true' readonly matSuffix
                        [for]="picker1">
                    </mat-datepicker-toggle>
                    <mat-datepicker readonly #picker1></mat-datepicker>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-error>*Application will not be considered unless signed by
                    an authorized representative. </mat-error>
            </mat-card-content>
            <mat-card-subtitle
                *ngIf="cgForm.get(['AuthorizedRep','signature']).valid">
                <b>Authorized Signature*: </b>
            </mat-card-subtitle>
            <mat-error
                *ngIf="cgForm.get(['AuthorizedRep','signature']).invalid">
                <b>Authorized Signature*: </b>
            </mat-error>
            <mat-card-subtitle>(Please use your mouse to sign in the space
                below)
            </mat-card-subtitle>
            <mat-card-content fxLayout="row" [fxShow.lt-sm]="false">
                <signature-pad style="border-style: solid; border: #009E49"
                    matInput [options]="signaturePadOptions"
                    (onEndEvent)="drawComplete()" #signaturePad></signature-pad>
            </mat-card-content>
            <mat-card-content fxLayout="row" [fxShow.lt-sm]="false">
                <button *ngIf="!isReadOnly && isShowSaveAsDraft" mat-flat-button
                    (click)="drawClear()" color="warn">Clear Signature</button>
            </mat-card-content>
            <div class="form-question-group" fxShow="false"
                [fxShow.lt-sm]="true">
                <mat-card-subtitle class="red-warning">
                    The signature pad is not supported with you device's
                    resolution.
                </mat-card-subtitle>
            </div>
        </div>
        <div class="form-question-group" *ngIf="isShowAccDist" fxLayout="column"
            fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Accounting Distribution *</b>
            </mat-card-subtitle>

            <div class="account-dist-container">

                <table style="padding: 16px" formArrayName="AccDistribution">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company</th>
                            <th>Project</th>
                            <th>Task</th>
                            <th>Exp-Type</th>
                            <th>Exp-Org</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i" *ngFor="let accDist of
                            cgForm.get('AccDistribution')['controls']; let
                            i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="company"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'company')">
                                        <mat-option value>--</mat-option>
                                        <mat-option *ngFor="let company of
                                            companyData[i]"
                                            [value]="company.code">
                                            {{company.descr}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="project"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'project')">
                                        <mat-option value>--</mat-option>
                                        <mat-option *ngFor="let project of
                                            projectData[i]"
                                            [value]="project.project">
                                            {{project.project}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="task"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'task')">
                                        <mat-option value>--</mat-option>
                                        <mat-option *ngFor="let task of
                                            taskData[i]"
                                            [value]="task.task">{{task.task}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expType"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expType')">
                                        <mat-option value>--</mat-option>
                                        <mat-option *ngFor="let expType of
                                            expTypeData[i]"
                                            [value]="expType.code">
                                            {{expType.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expOrg"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expOrg')">
                                        <mat-option value>--</mat-option>
                                        <mat-option *ngFor="let expOrg of
                                            expOrgData[i]"
                                            [value]="expOrg.code">
                                            {{expOrg.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input DecimalTrail style="text-align:
                                        center;" type="text" matInput
                                        (change)="onAmountChange($event.target.value,i)"
                                        (input)="calculateTotalAmount()"
                                        maxlength="12" formControlName="amount"
                                        [readonly]='!isAccDistEditable'>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">
                                <b>Total Awarded Amount:</b>
                            </td>
                            <td style="text-align: center;">
                                <span>
                                    <b>$ {{cgForm.value.amount}}</b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        &nbsp;
        <div class="form-question-group" fxLayout="column"
            *ngIf="isAwardedAmount">
            <mat-card-subtitle>
                <b>Total Awarded Amount</b>
            </mat-card-subtitle>
            <mat-form-field>
                <input DecimalTrail formControlName='amount'
                    [readonly]="isReadOnly || !isAwardedAmountEditable"
                    placeholder="Amount Awarded" maxlength="12"
                    formControlName="amount" matInput type="text"
                    [required]='[3,9,11,23].includes(cgForm.value.statusId)'>
                <span matPrefix>$&nbsp;</span>
            </mat-form-field>
        </div>
    </form>
</div> <br><br>
<div class="action-bar">
    <div matRipple class="action-button warn-button" color="warn"
        (click)="onCancel()">Cancel</div>
    <div matRipple class="action-button secondary-button"
        *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()" color="primary">Save
        As Draft</div>
    <div matRipple class="action-button primary-button"
        *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()" color="primary">Submit</div>
    <div matRipple class="action-button secondary-button"
        *ngIf="isShowSaveButton"
        (click)="onSubmit()" color="primary">Save
        Change(s)</div>
    <div matRipple class="action-button secondary-button" *ngIf="hasRole('DEV')"
        (click)="onUpdateFormStatus()" color="primary">Change Form Status</div>
    <div matRipple class="action-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onWithdrawRejectReassign('Rejected')" color="warn">Reject</div>
    <div matRipple class="action-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()" color="primary">Approve</div>
    <div matRipple class="action-button secondary-button"
        *ngIf="isShowReassignBtn"
        (click)="onWithdrawRejectReassign('Reassigned')"
        color="primary">Reassign To CIT</div>
    <div matRipple class="action-button warn-secondary-button"
        *ngIf="isShowWithdrawBtn"
        (click)="onWithdrawRejectReassign('Withdrawn')"
        color="warn">Withdraw</div>
</div>